import React from 'react';

interface TabsProps {
  tabs: React.ReactNode[];
  selected: number;
  onSelect: (idx: number) => void;
  style?: React.CSSProperties;
}

const Tabs: React.FC<TabsProps> = ({ tabs, selected, onSelect, style }) => (
  <div style={{ display: 'flex', gap: 8, borderBottom: '2px solid #e2e8f0', marginBottom: 18, overflowX: 'auto', WebkitOverflowScrolling: 'touch', ...style }}>
    {tabs.map((tab, idx) => (
      <button
        key={idx}
        onClick={() => onSelect(idx)}
        style={{
          background: 'none',
          border: 'none',
          borderBottom: selected === idx ? '3px solid #38b2ac' : '3px solid transparent',
          color: selected === idx ? '#222' : '#888',
          fontWeight: selected === idx ? 700 : 500,
          fontSize: 17,
          padding: '8px 18px',
          cursor: 'pointer',
          outline: 'none',
          flexShrink: 0,
          whiteSpace: 'nowrap',
          transition: 'color 0.2s, border-bottom 0.2s',
        }}
      >
        {tab}
      </button>
    ))}
  </div>
);

export default Tabs; 